import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const PushoverShape = {
  user: Yup.string().label("Recipient Key").required(),
  priority: Yup.string().required(),
};

export interface PushoverInput {
  user: string;
  priority: string;
}

export const PushoverDefaults = {
  priority: "0",
};

yupResolver<PushoverInput>(Yup.object().shape(PushoverShape));
